import React from 'react';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const EllipseIcon: React.FC<React.PropsWithChildren<unknown>> = () => {
	return <FontAwesomeIcon icon={faEllipsis} />;
};

export default EllipseIcon;
